import Api from '../Base'

class PostGenerateCycleCategoriesByCycleId extends Api {
  requestUrl = `/api/SharepointNomination/${this.getParams().cycleId}/refresh`

  method = 'POST'
}
export default PostGenerateCycleCategoriesByCycleId
